import { render, staticRenderFns } from "./ListReferralCampaign.vue?vue&type=template&id=465a8bc2&scoped=true"
import script from "./ListReferralCampaign.vue?vue&type=script&lang=js"
export * from "./ListReferralCampaign.vue?vue&type=script&lang=js"
import style0 from "./ListReferralCampaign.vue?vue&type=style&index=0&id=465a8bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a8bc2",
  null
  
)

export default component.exports